import { render, staticRenderFns } from "./salesResult.vue?vue&type=template&id=37413214&"
import script from "./salesResult.vue?vue&type=script&lang=js&"
export * from "./salesResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports